/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateServiceVersionDto
 */
export interface CreateServiceVersionDto {
    /**
     * The name of the version.
     * @type {string}
     * @memberof CreateServiceVersionDto
     */
    name: string;
    /**
     * The YAML definition.
     * @type {string}
     * @memberof CreateServiceVersionDto
     */
    definition: string;
    /**
     * The environment settings.
     * @type {{ [key: string]: string; }}
     * @memberof CreateServiceVersionDto
     */
    environment: { [key: string]: string; };
    /**
     * Indicates if the version is active.
     * @type {boolean}
     * @memberof CreateServiceVersionDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the CreateServiceVersionDto interface.
 */
export function instanceOfCreateServiceVersionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "definition" in value;
    isInstance = isInstance && "environment" in value;
    isInstance = isInstance && "isActive" in value;

    return isInstance;
}

export function CreateServiceVersionDtoFromJSON(json: any): CreateServiceVersionDto {
    return CreateServiceVersionDtoFromJSONTyped(json, false);
}

export function CreateServiceVersionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceVersionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'definition': json['definition'],
        'environment': json['environment'],
        'isActive': json['isActive'],
    };
}

export function CreateServiceVersionDtoToJSON(value?: CreateServiceVersionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'definition': value.definition,
        'environment': value.environment,
        'isActive': value.isActive,
    };
}

